export default "__VITE_ASSET__Da93NbJV__"